import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import {} from "react-share";
import "./header.scss";

// import { userService } from "../../services/user.service";
import { useSelector } from "react-redux";
// import { backendService } from "../../services/backend.service";
import LogoCompany from "../../assets/imgs/R_C.png";
import { ImgCache } from "../CustonHooks/imgCache";

export function OpenHeader({ MyFun, activeBtn, userProfile }) {
  const history = useHistory();
  const roleName = useSelector((state) => state.userSettings.roleName);

  const companyLogo = useSelector((state) => state.userSettings.companyLogo);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => {
    setDropdownOpen((prevState) => !prevState);
  };
  ///////////
  const [dropdownOpenShare, setDropdownOpenShare] = useState(false);
  const toggleShare = () => {
    setDropdownOpenShare((prevState) => !prevState);
  };
  // const [tooltipOpen, setTooltipOpen] = useState(false);
  // const togglex = () => setTooltipOpen(!tooltipOpen);

  const [dropdownOpenPro, setDropdownOpenPro] = useState(false);
  const toggleProfile = () => {
    setDropdownOpenPro((prevState) => !prevState);
  };


  const miPerfil = () => {
    history.push("profile");
  };



  let urls = window.location.href;
  return (
    <header className="wrapper_header trans">
      <div className="box_brand">
        <span className={`btn_menu ${activeBtn}`} onClick={MyFun}>
          <span></span>
          <span></span>
          <span></span>
        </span>
        <NavLink to={roleName == "Operaciones" ? "/homeOps/1" : "/home"}>
          <ImgCache src={companyLogo ? companyLogo : LogoCompany} alt="Brand" />
        </NavLink>
      </div>
      <div className="content_header">
        <div className="box_options">
          <Dropdown isOpen={dropdownOpenShare} toggle={toggleShare}>
            <DropdownToggle
              className="btn_notifications ico_share"
              tag="span"
              aria-expanded={dropdownOpenShare}
            >
              <span className="icon_bell">
                <i className="fa-solid fa-share-nodes"></i>
              </span>
            </DropdownToggle>
            <DropdownMenu className="popup" right>
              <header>
                <span>Compartir</span>
              </header>

              <div className="content">
                <p>Comparte esta página</p>
                <ul className="icons">
                  <FacebookShareButton
                    url={urls}
                    //quote={}
                    //hashtag={}
                    //description={}
                    className="Demo__some-network__share-button"
                  >
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                  <TwitterShareButton
                    //title={"test"}
                    url={urls}
                    //hashtags={}
                  >
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                  <WhatsappShareButton
                    url={urls}
                    //quote={}
                    //hashtag={}
                    // description={}
                    className="Demo__some-network__share-button"
                  >
                    <WhatsappIcon size={32} round />
                  </WhatsappShareButton>
                  <LinkedinShareButton
                    //title={"test"}
                    url={urls}
                    // hashtags={}
                  >
                    <LinkedinIcon size={32} round />
                  </LinkedinShareButton>

                  <EmailShareButton url={urls}>
                    <EmailIcon size={32} round />
                  </EmailShareButton>
                </ul>
                <p>O copia el link</p>
                <div className="field">
                  <i className="fa-solid fa-link"></i>
                  <input type="text" readOnly value={urls}></input>
                  <button
                    className="btn_copy"
                    onClick={() => navigator.clipboard.writeText(urls)}
                  >
                    copiar
                  </button>
                </div>
              </div>
            </DropdownMenu>
          </Dropdown>
          {/**************************** */}
        </div>
      </div>
    </header>
  );
}
